<template>
  <div class="downloadable">
    <ul v-for="f in files">
      <li class="flex flex-nowrap justify-between items-center w-3/4">
        <div class="flex flex-nowrap items-center">
          <i class="el-icon-paperclip self-start mt-1"></i>
          <div class="px-4 font-normal break-all text-justify">
            {{ f.name }}
          </div>
        </div>
        <el-button class="flex-shrink-0 self-start" style="padding: 0" type="text" @click="downloadFile(f)">下载</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Downloadable',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    files() {
      return this.rowData.questionDetails.content.file || []
    }
  },
  methods: {
    downloadFile(file) {
      var a = document.createElement('a')
      const fileNameArr = file.name.split('.')
      fileNameArr.pop()
      a.href =
        window.location.origin + '/fill/api/v1/downloadWithName?fileName=' + file.url + '&downLoadName=' + fileNameArr.join('.')
      a.click()
    }
  }
}
</script>
<style lang="scss" scoped>
.downloadable {
}
</style>
